<template>
  <v-app id="inspire">
    <template v-if="!$route.meta.allowAnonymous">
        <v-content>
          <router-view></router-view>
        </v-content>
    </template>
    <template v-else>
      <navigation :toggle="drawer"/>
      <toolbar @toggleNavigationBar="drawer = !drawer" :name="$route.meta.name"/>
      <v-content>
        <router-view />
      </v-content>
      <v-footer color="primary" app>
        <span class="white--text"> {{name}} &copy; {{ year() }}</span>
        <v-spacer></v-spacer>
        <span class="white--text"> Version {{ version }}</span>
      </v-footer>
      <MainFormDialog v-if="get_MainFormDialog.dialog" />
      <MainMessageDialog v-if="get_MainMessageDialog.dialog" />
      <MainProcessLoadingDialog v-if="get_MainProgressDialog.dialog" />

    </template>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import MainMessageDialog from '@/components/dialogs/MainMessageDialog'
import MainProcessLoadingDialog from '@/components/dialogs/MainProcessLoadingDialog'
export default {
  name: 'App',
  data: () => ({
    drawer: false,
    name: process.env.VUE_APP_COMPANY_NAME,
    version: process.env.VUE_APP_VERSION
  }),
  components: {
    MainFormDialog,
    MainMessageDialog,
    MainProcessLoadingDialog
  },
  mounted () {

  },
  methods: {
    year () {
      const year = new Date().toISOString().substr(0, 4)
      return year
    }
  },
  computed: {
    ...mapGetters(['get_MainFormDialog', 'get_MainMessageDialog', 'get_MainProgressDialog'])
  }
}
// iisexpress-proxy 3000 to 3024
</script>
<style scoped>
#inspire {
  background-color: #EEEEEE;
}
.theme{
  background-color: #d6d6d6;
}
</style>
